import React from 'react';
import { Query } from 'react-apollo';
import numeral from 'numeral';
import gql from 'graphql-tag';

import SEO from '../components/seo';
import Layout from '../components/layout';
import Statistic from '../components/Statistic/Statistic';
import HeaderList from '../components/HeaderList/HeaderList';
import Contact from '../components/Contact/Contact';
import HomeFeature from '../components/HomeFeature/HomeFeature';
import Subscribe from '../components/Subscribe/Subscribe';
import NumberImage from '../components/NumberImage/NumberImage';
import NonStretchedImage from '../components/NonStretchedImage/NonStretchedImage';
import { useStaticQuery, graphql } from 'gatsby';

const absoluteCeter = {
  left: '50%',
  transform: 'translate(-50%)',
};

const IndexPage = () => {
  const result = useStaticQuery(
    graphql`
      {
        file(relativePath: { eq: "hero-home.png" }) {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
              presentationWidth
            }
          }
        }
      }
    `
  );

  const TOTALS = gql`
    {
      totals {
        companies
        term
        raisedMoney
        funded
      }
    }
  `

  return (
    <Layout>
      <SEO title="Inicio" />
      <section className="min-h-screen relative pt-0 md:pt-0">
        <div className="max-w-7xl h-full mx-auto">
          <div className="px-5 py-24 md:py-40 md:my-0">
            <h1 className="text-3xl py-4 md:text-5xl md:max-w-2xl font-thin leading-normal text-gray-700">
              La solución de{' '}
              <span className="text-red-100">factoraje financiero</span> para
              todos
            </h1>
            <p className="text-gray-700 md:text-xl md:max-w-2xl font-thin">
              Somos una empresa mexicana que ofrece soluciones de liquidez a
              empresas y grandes beneficios a inversionistas.
            </p>
          </div>
        </div>
        <NonStretchedImage
          style={{ top: '-80px' }}
          className="absolute bottom-0 min-h-screen md:max-h-screen object-cover w-full back"
          fluid={result.file.childImageSharp.fluid}
          alt="Factoraje financiero"
        />
        <div
          style={absoluteCeter}
          className="bg-white py-4 px-10 absolute shadow-xl w-11/12 md:w-12/12 xl:w-9/12 md:bottom-0"
        >
          <HeaderList />
        </div>
      </section>
      <section className="z-50 py-16 max-w-7xl mx-auto">
        <div className="px-5">
          <h2 className="text-center text-3xl py-4 md:text-5xl leading-normal text-black-100 font-display">
            Una solución de fondeo
          </h2>
          <p className="text-gray-700 text-center md:text-xl font-normal font-display">
            Resolvemos los problemas de flujo de efectivo de las empresas por
            medio de una plataforma de factoraje financiero; ofrecemos una
            alternativa de inversión a personas físicas y morales.
          </p>
        </div>
      </section>
      <section className="px-4 max-w-7xl mx-auto py-20  md:flex">
        <HomeFeature
          to="/factorados"
          icon="factorado"
          title="Factorados"
          className="md:pr-20"
          description="¿Tienes clientes que te pagan a plazos mayores de 30 días, pero necesitas liquidez lo antes posible con una tasa de interés baja?"
        />
        <HomeFeature
          to="/inversionistas"
          icon="inversionista"
          title="Inversionistas"
          className="md:pr-20"
          description="¿Quisieras apoyar a empresas mexicanas?
          Invierte en su capital de trabajo fondeando facturas y recibe altos rendimientos a corto plazo."
        />
        <HomeFeature
          to="/deudores"
          icon="deudor"
          title="Deudores"
          description="¿Quieres ayudar a tus proveedores ofreciéndoles una alternativa de liquidez inmediata en tus cuentas por pagar sin afectar tus flujos?"
        />
      </section>
      <section className="px-5 max-w-7xl mx-auto pb-20 md:my-0 md:mb-40">
        <h2 className="text-center text-3xl py-4 md:text-5xl leading-normal text-black-100 font-display">
          Nuestros números hablan
        </h2>
        <Query query={TOTALS}>
          {({ data, error, loading }) => {
            if (loading || error) {
              return null;
            }
            return (
              <div className="md:flex">
                <article className="text-center md:w-1/2 md:flex md:flex-wrap">
                  <Statistic
                    number={`${data.totals.funded+30}`}
                    title="Facturas fondeadas"
                    className="mb-4"
                  />
                  <Statistic
                    className="mb-4"
                    number={(
                      <span className="uppercase">
                        {numeral(data.totals.raisedMoney+717343.61).format('$0.0a')}
                      </span>
                    )}
                    title="Capital colocado"
                  />
                  <Statistic
                    number={`${Math.ceil(data.totals.term)} días`}
                    title="Plazo promedio"
                    className="mb-4"
                  />
                  <Statistic number={data.totals.companies} title="Empresas afiliadas" />
                </article>
                <NumberImage />
              </div>
            )
          }}
        </Query>
      </section>
      <Contact />
      <Subscribe />
    </Layout>
  );
};

export default IndexPage;
